module.exports = __webpack_public_path__ + "static/media/lineognicolai.70330fbb.PNG";